import React, { FC } from "react";
import { RouteProps } from "react-router-dom";
import { ParallaxProvider } from "react-scroll-parallax";

export const withPage = (WrappedComponent: FC<RouteProps>) => {
	const HOC = (props: any) => (
		<div className="w-screen px-8 md:px-36 mb-48 mt-28">
			<ParallaxProvider>
				<WrappedComponent {...props} />
			</ParallaxProvider>
		</div>
	);

	return HOC;
};
